import Vuex from "vuex";
import Vue from "vue";
import createPersistedState from "vuex-persistedstate";

// Modules
import giftCardCart from "./modules/giftCardCart";
import giftCardRedemption from "./modules/giftCardRedemption";


// Load Vuex
Vue.use(Vuex);

const state = {};

const mutations = {};

// Create store
export default new Vuex.Store({
    state,
    mutations,
    modules: {
        giftCardCart,
        giftCardRedemption,
    },
    plugins: [createPersistedState({
        key: 'STD',
    })],
});
